import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  CheckoutAuthResponse,
  CheckoutCustomerDetails,
  CheckoutTokenRequest,
  IpsMelissaValidation,
  QuoteResponse,
  REGISTRATION_CONFIG,
  RegistrationConfig,
  RegistrationCPGRequest,
  RegistrationRequest,
  RegistrationResponse,
  RegistriaUpdateUserOrderRequest,
  RegistriaUserRequest,
  RegistriaUsersResponse,
} from '@us-registration/util-models';

import { RegistrationCPGResponse } from '@us-registration/util-models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  quote: QuoteResponse = {} as QuoteResponse;
  checkoutAuthToken: string | undefined;
  checkoutCustomer = {} as CheckoutCustomerDetails | undefined;

  constructor(
    @Inject(REGISTRATION_CONFIG)
    protected readonly registrationConfig: RegistrationConfig,
    protected readonly httpClient: HttpClient
  ) {}

  getApplianceCPG(
    registrationCPGRequest: RegistrationCPGRequest
  ): Observable<RegistrationCPGResponse | string> {
    const params = `?modelNumber=${registrationCPGRequest.modelNumber}`;

    return this.httpClient
      .get<RegistrationCPGResponse>(
        `${this.registrationConfig.cpgFinderApi}${params}`
      )
      .pipe(
        map(
          (
            response: RegistrationCPGResponse
          ): RegistrationCPGResponse | string => response
        )
      );
  }

  registerAppliance(
    registrationRequest: RegistrationRequest
  ): Observable<RegistrationResponse> {
    return this.httpClient
      .post<RegistrationResponse>(
        `${this.registrationConfig.registrationApi}`,
        registrationRequest
      )
      .pipe(map((response: RegistrationResponse) => response));
  }

  getQuote(
    registrationRequest: RegistrationRequest
  ): Observable<QuoteResponse> {
    return this.httpClient
      .post<QuoteResponse>(
        `${this.registrationConfig.wibApi}/quote`,
        registrationRequest,
        { observe: 'response' }
      )
      .pipe(
        map((response) => {
          return {
            ...(response.body as QuoteResponse),
            status: response.status,
          };
        })
      );
  }

  registriaUsers(
    registriaRequest: RegistriaUserRequest | RegistriaUpdateUserOrderRequest
  ): Observable<RegistriaUsersResponse> {
    return this.httpClient
      .post<{ result: RegistriaUsersResponse }>(
        `${this.registrationConfig.registriaUsersApi}`,
        registriaRequest
      )
      .pipe(
        map((response: { result: RegistriaUsersResponse }) => response.result)
      );
  }

  registerEmailValidation(
    registrationEmailValidationRequest: string
  ): Observable<IpsMelissaValidation> {
    const params = `?email=${registrationEmailValidationRequest}`;

    return this.httpClient
      .get<IpsMelissaValidation>(
        `${this.registrationConfig.wibApi}/melissa${params}`
      )
      .pipe(
        map((response: IpsMelissaValidation) => {
          return response;
        })
      );
  }

  registerPhoneNumberValidation(
    registrationPhoneNumberValidationRequest: string
  ): Observable<IpsMelissaValidation> {
    const params = `?phoneNumber=${registrationPhoneNumberValidationRequest}`;

    return this.httpClient
      .get<IpsMelissaValidation>(
        `${this.registrationConfig.wibApi}/melissa${params}`
      )
      .pipe(
        map((response: IpsMelissaValidation) => {
          return response;
        })
      );
  }

  getCheckoutToken(): Observable<CheckoutAuthResponse> {
    const req: CheckoutTokenRequest = {
      channelSourceData: {
        checkoutSourceRef: 'whirlpool_client_portal',
      },
    };

    return this.httpClient
      .post<CheckoutAuthResponse>(
        `${this.registrationConfig.wibApi}/token`,
        req
      )
      .pipe(map((res: CheckoutAuthResponse) => res));
  }
}
